import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.tsx";
import "./App.css";
import "./index.scss";
import "react-responsive-carousel/lib/styles/carousel.min.css";

declare global {
  interface OneTrustType {
    ToggleInfoDisplay: () => void;
  }

  interface Window {
    OneTrust: OneTrustType;
  }
}

createRoot(document.getElementById("app")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
